var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-scroll-wrap"},[_vm._t("before"),_c('div',{staticClass:"horizontal-scroll-outer-wrap"},[_c('div',{staticClass:"horizontal-scroll-inner-wrap"},[_vm._t("default")],2)]),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }